import { render, staticRenderFns } from "./listagemSolicitacoes.vue?vue&type=template&id=656d5194&scoped=true&lang=pug&"
import script from "./listagemSolicitacoes.vue?vue&type=script&lang=js&"
export * from "./listagemSolicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./listagemSolicitacoes.vue?vue&type=style&index=0&id=656d5194&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656d5194",
  null
  
)

export default component.exports